(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["nov-product-recommendations"]) return;
  try {
    
  class ProductRecommendations extends HTMLElement {
    constructor() {
      super();
    }
    connectedCallback() {
      const handleIntersection = (entries, observer) => {
        if (!entries[0].isIntersecting) return;
        observer.unobserve(this);
        fetch(this.dataset.url)
          .then(response => response.text())
          .then(text => {
            const html = document.createElement('div');
            html.innerHTML = text;
            const recommendations = html.querySelector('product-recommendations');
            if (recommendations && recommendations.innerHTML.trim().length) {
              this.innerHTML = recommendations.innerHTML;
            }
          })
          .catch(e => {
            console.error(e);
          });
      }
      new IntersectionObserver(handleIntersection.bind(this), {rootMargin: '0px 0px 200px 0px'}).observe(this);
    }
  }
  customElements.define('product-recommendations', ProductRecommendations);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-holiday-catalogue"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click', function(event) {
  const open = event.target.closest('[data-holiday-open]');
  const close = event.target.closest('[data-holiday-close]');
  if (!open && !close) return;
  const section = (open || close).closest('.sb-holiday');
  const viewer = section.querySelector('.sb-holiday__viewer');
  const trigger = section.querySelector('[data-holiday-open]');
  event.preventDefault();
  if (open) {
    const holder = section.querySelector('[data-holiday-frame]');
    if (!holder.querySelector('iframe')) {
      const frame = document.createElement('iframe');
      frame.src = holder.dataset.url;
      frame.title = holder.dataset.title;
      frame.allowFullscreen = true;
      holder.appendChild(frame);
    }
    viewer.hidden = false;
    trigger.setAttribute('aria-expanded', 'true');
    viewer.querySelector('button').focus({preventScroll:true});
    viewer.scrollIntoView({block:'start',behavior:'instant'});
  } else {
    viewer.hidden = true;
    trigger.setAttribute('aria-expanded', 'false');
    trigger.focus();
  }
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["sb-home-hero"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('sb-launch-slideshow')) {
class SBLaunchSlideshow extends HTMLElement {
connectedCallback(){
this.slides=Array.from(this.querySelectorAll('[data-slide]'));this.index=0;this.paused=window.matchMedia('(prefers-reduced-motion: reduce)').matches;this.hovering=false;
this.controls=this.querySelector('.sb-slide-controls');this.controls.hidden=false;this.pause=this.querySelector('[data-pause]');
this.querySelectorAll('[data-select]').forEach(b=>b.addEventListener('click',()=>{this.show(Number(b.dataset.select));this.start();}));
this.pause.addEventListener('click',()=>{this.paused=!this.paused;this.sync();});
this.addEventListener('mouseenter',()=>{this.hovering=true;});
this.addEventListener('mouseleave',()=>{this.hovering=false;});
this.addEventListener('focusout',()=>{this.start();});
this.start();
this.sync();
}
start(){clearInterval(this.timer);this.timer=setInterval(()=>{if(!this.paused&&!document.hidden&&!this.querySelector(':focus-visible'))this.show((this.index+1)%this.slides.length);},15000);}
show(i){this.index=i;this.dataset.active=String(i);this.slides.forEach((s,n)=>{s.hidden=n!==i;});this.querySelectorAll('[data-select]').forEach((b,n)=>b.setAttribute('aria-pressed',String(n===i)));}
sync(){this.pause.textContent=this.paused?'Play':'Pause';this.pause.setAttribute('aria-label',this.paused?'Play slideshow':'Pause slideshow');}
disconnectedCallback(){clearInterval(this.timer);}
}
customElements.define('sb-launch-slideshow',SBLaunchSlideshow);
}

  } catch(e) { console.error(e); }
})();
})();
